<template>
  <div class="success-modal">
    <img src="/img/icons/star_check.svg" alt="" class="success-modal__icon" />
    <div class="success-modal__title">
      {{ data?.message || 'Смета успешно пересчитана' }}
    </div>
    <div v-if="data?.description" class="success-modal__description">
      {{ data.description }}
    </div>
  </div>
  <CustomModalFooter
    :btn-loading="loading"
    :submit-btn-text="data?.btnText || 'Подтвердить'"
    :on-submit="onSubmit"
    :onCancel="onCancel" 
    :centered="true"
    :hideCancelBtn="true"
  />
</template>

<script>
import CustomModalFooter from '@/components/modal/modals/modal-footer'
import { useAppStore } from '@/services/store/app'

export default {
  name: 'SmetaRecalcSuccess',
  props: ['data'],
  components: { CustomModalFooter },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    async onSubmit() {
      if (!this.data?.onSubmit) return
      this.loading = true
      await this.data.onSubmit()
      this.loading = false
    },
    onCancel() {
      this.closeModal()
    },
  },
  setup() {
    const { closeModal } = useAppStore()
    return { closeModal }
  },
}
</script>

<style scoped lang="scss">
.success-modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 10px 10px;
  min-width: 500px;

  @media (max-width: 576px) {
    min-width: 100%;
  }

  &__icon {
    width: 70px;
    height: 70px;
    margin-bottom: 16px;
  }

  &__title {
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    color: #1d1d1d;
  }

  &__description {
    font-size: 14px;
    color: #666;
    text-align: center;
    margin-top: 8px;
  }
}
</style>
